import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

/**
 * Props for CustomTooltip component.
 * - Default background color: white
 * - Default text color: black
 * - Supports custom title, bgColor, textColor, arrow, placement
 */
export type CustomTooltipProps = Omit<TooltipProps, 'title'> & {
  /** Content to display inside the tooltip */
  title: React.ReactNode;
  /** Background color (default: '#ffffff') */
  bgColor?: string;
  /** Text color (default: '#000000') */
  textColor?: string;
};

/**
 * CustomTooltip component
 * Wraps MUI Tooltip to allow custom background and text colors.
 * @param props - CustomTooltipProps
 */
export default function CustomTooltip(
  {
    title,
    bgColor = '#ffffdd',
    textColor = '#000000',
    children,
    arrow = true,
    placement = 'top',
    ...rest
  }: CustomTooltipProps
) {
  return (
    <Tooltip
      title={title}
      arrow={arrow}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: bgColor,
            color: textColor,
            fontSize: 14,
          },
        },
        arrow: {
          sx: {
            color: bgColor,
          },
        },
      }}
      {...rest}
    >
      {children}
    </Tooltip>
  );
}
